import { NavLink } from "react-router-dom";
import { Home, LayoutGrid, ListOrdered, MessageSquare } from "lucide-react";

const TABS = [
  { to: "/", label: "Home", icon: Home, id: "home", end: true },
  { to: "/services", label: "Services", icon: LayoutGrid, id: "services" },
  { to: "/how-it-works", label: "Process", icon: ListOrdered, id: "process" },
  { to: "/contact", label: "Contact", icon: MessageSquare, id: "contact" },
];

export default function BottomTabs() {
  return (
    <nav
      data-testid="bottom-tabs"
      aria-label="App navigation"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-[#0C0C10]/95 backdrop-blur-xl border-t border-[rgba(212,175,55,0.18)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-4">
        {TABS.map((t) => (
          <NavLink
            key={t.id}
            to={t.to}
            end={t.end}
            data-testid={`tab-${t.id}`}
            className={({ isActive }) =>
              `relative flex flex-col items-center gap-1 py-2.5 text-[10px] tracking-wide transition-colors duration-200 ${
                isActive ? "text-[#E6CA65]" : "text-[#71717A]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                {isActive && <span className="absolute top-0 w-8 h-0.5 rounded-full bg-[#D4AF37]" />}
                <t.icon size={20} strokeWidth={isActive ? 2 : 1.5} />
                {t.label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
